import mixin from './../mixin';
import TableProcessDeleteTableRowResultMixin from './process_delete_table_row_result_mixin';

class TableDeleteOneRowMixin {

//  abstract methods
//
//  get table_element();
//  get lang();
//  showLoadingBlock();
//  hideLoadingBlock();
//
//  abstract methods from TableProcessDeleteTableRowResultMixin
//
// _addFilterUrlArgs(base_url);
// _resetViewAfterTableRowDeletion();
// _reinitDynamicBlock(html);
// _processWrongResult(result);


  get table_row_delete_links() {
    return this.table_element.find('.delete');
  }

  _initTableRowsDeleteLinks() {

    var table = this;

    this.table_row_delete_links.click(function (event) {

      event.preventDefault();

      let table_row_id = $(this).data('table_row_id');

      let confirm_message = table.lang.format(
        'confirm_one_row_delete',
        [table_row_id]
      );

      if (!confirm(confirm_message)) {
        return false;
      }

      $.ajax({
        url: table._addFilterUrlArgs($(this).attr('href')),
        type: 'post',
        dataType: 'json',
        beforeSend: table.showLoadingBlock.bind(table),
        complete: table.hideLoadingBlock.bind(table),
        success: table._processDeleteTableRowResult.bind(table)
      });

      return false;
    });
  }
}

mixin(TableDeleteOneRowMixin, TableProcessDeleteTableRowResultMixin);

export default TableDeleteOneRowMixin;


/** WEBPACK FOOTER **
 ** ./src/common/table/delete_one_row_mixin.js
 **/